import { InteractiveArea } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ProductDiscountWrapper = styled.div`
  margin: -0.5rem 0 1rem 0;
`;

export const StyledInteractiveArea = styled(InteractiveArea)`
  vertical-align: middle;
  position: relative;
  margin-left: 3px;
  top: -4px;
  height: 1rem;
  z-index: 99;
  cursor: pointer;
  .interactive-area {
    transform: translate(-50%, -18px);
    height: 1.75rem;
    z-index: 9999;
  }
`;

export const TooltipContent = styled.div`
  min-width: 15rem;
`;
